import { replace } from 'svelte-spa-router'
import { adminStore } from './stores'
import StorageService from './$services/storage.service'

export {
    needLogin,
    isLogin
}

async function needLogin(detail) {

    const access = StorageService.getItem('access')
    const user = StorageService.getItem('user')

    if(user)
        adminStore.set(user)

    if(!access || !user)
        return true

    const roles = ['admin', 'adviser', 'support', 'seller']

    if(roles.indexOf(user.role) === -1)
        return true

    switch(user.role) {
        case 'admin': replace('#/shipments'); break
        case 'support': replace('#/shipments'); break
        case 'adviser': replace('#/users'); break
        case 'seller': replace('#/clients'); break
        default: replace('#/shipments')
    }

    return false
}

async function isLogin(detail) {

    const access = StorageService.getItem('access')
    const user = StorageService.getItem('user')

    if(user)
        adminStore.set(user)

    const roles = ['admin', 'adviser', 'support', 'seller']

    if(access && user && roles.indexOf(user.role) >= 0)
        return true

    replace('#/')
    return false
}